import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { LightOutlineButton } from 'components/Buttons';
import { ArrowReturnLeft, HandThumbsDown, HandThumbsUp } from 'react-bootstrap-icons';
import Constants from 'config/Constants';
import { getBlockIdsInBlockLayout } from 'pages/global/BlockLayoutHelper';

export function RestoreBlock({ block, index, readOnly = false }) {
    const { t } = useTranslation('documents');
    const { values, setFieldValue } = useFormikContext();
    const { areaBlocks } = values;

    if (block.deletionRejected) {
        return (
            <div className="success-block-content py-2 text-center small">
                Blok is weer beschikbaar na het opslaan.
            </div>
        );
    }

    const canUndo = !block.scheduledForDeletion && !block.deletionAccepted && !readOnly;
    const canAccept = !readOnly;

    return (
        <div className="restore-block-content py-2 text-danger text-center small">
            {block.scheduledForDeletion ? (
                <>
                    <div>{t('document.navbar.main.editor.left.blocks.badges.markedForDeletion')}</div>

                    {canAccept && (
                        <div className="d-flex justify-content-center flex-wrap mt-2">
                            <LightOutlineButton
                                size="sm"
                                className="px-2 mr-2"
                                onClick={() => processDeletedBlock('accept')}
                            >
                                <HandThumbsUp size={14} className="mr-2" />
                                {t('document.navbar.main.editor.left.blocks.acceptDeletion')}
                            </LightOutlineButton>

                            <LightOutlineButton
                                size="sm"
                                className="px-2"
                                onClick={() => processDeletedBlock('reject')}
                            >
                                <HandThumbsDown size={14} className="mr-2" />
                                {t('document.navbar.main.editor.left.blocks.rejectDeletion')}
                            </LightOutlineButton>
                        </div>
                    )}
                </>
            ) : (
                <>
                    {t('document.navbar.main.editor.left.blocks.badges.removeWhenSaving')}

                    {canUndo && (
                        <a onClick={handleBlockRestore}>
                            <ArrowReturnLeft size={15} className="mr-2 ml-3" />
                            {t('document.navbar.main.editor.left.blocks.badges.restoreBlock')}
                        </a>
                    )}
                </>
            )}
        </div>
    );

    function processDeletedBlock(action) {
        // Change rejected?
        if (action === 'reject') {
            setFieldValue(`areaBlocks.${index}`, {
                ...block,
                deletionRejected: true, // marks this block, so we can still view it until the user hit the save button
                scheduledForDeletion: false,
            });
            // setFieldValue(`areaBlocks.${index}.scheduledForDeletion`, false);
            return;
        }

        // Change accepted
        setFieldValue(`areaBlocks.${index}`, {
            ...block,
            deleted: true,
            deletionAccepted: true, // marks this block, so we can still view it until the user hit the save button
            scheduledForDeletion: false,
        });
    }

    function handleBlockRestore() {
        if (block.type === Constants.blockTypes.blockLayout) {
            const blockIds = [block.id].concat(getBlockIdsInBlockLayout(block));

            const newAreaBlocks = areaBlocks.map((areaBlock) => {
                if (blockIds.includes(areaBlock.key)) {
                    return {
                        ...areaBlock,
                        deleted: undefined,
                    };
                }

                return areaBlock;
            });

            setFieldValue('areaBlocks', newAreaBlocks);
        } else {
            setFieldValue(`areaBlocks.${index}.deleted`, undefined);
        }
    }
}
